import { render, staticRenderFns } from "./projectA.vue?vue&type=template&id=75c1d4c8&scoped=true&"
import script from "./projectA.vue?vue&type=script&lang=js&"
export * from "./projectA.vue?vue&type=script&lang=js&"
import style0 from "./projectA.vue?vue&type=style&index=0&id=75c1d4c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c1d4c8",
  null
  
)

export default component.exports